export default __webpack_public_path__ + "static/media/featureTwo.52c51bda.svg";